export default __webpack_public_path__ + "static/media/short-text-blue.a48557ae.svg";